import React, { useState } from 'react';
import { AlertTriangle, Play, Pause } from 'lucide-react';
import toast from 'react-hot-toast';
import { useContestStatus } from '../../hooks/useContestStatus';
import { toggleContestStatus } from '../../services/contestService';
import ContestStatusCard from './ContestStatusCard';

export default function ContestStatus() {
  const { isEnded, lastUpdated, loading } = useContestStatus();
  const [updating, setUpdating] = useState(false);

  const handleToggleContest = async () => {
    const action = isEnded ? 'reactivar' : 'finalizar';
    if (!window.confirm(`¿Estás seguro de que quieres ${action} el concurso?`)) {
      return;
    }

    setUpdating(true);
    try {
      await toggleContestStatus(!isEnded);
      toast.success(`Concurso ${isEnded ? 'reactivado' : 'finalizado'} correctamente`);
    } catch (error) {
      console.error('Error toggling contest:', error);
      toast.error(`Error al ${action} el concurso`);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="animate-pulse bg-white rounded-lg p-6">
        <div className="h-8 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-900">Estado del Concurso</h2>
        <button
          onClick={handleToggleContest}
          disabled={updating}
          className={`px-4 py-2 rounded-lg flex items-center transition-colors disabled:opacity-50 ${
            isEnded 
              ? 'bg-green-500 hover:bg-green-600 text-white'
              : 'bg-red-500 hover:bg-red-600 text-white'
          }`}
        >
          {isEnded ? (
            <Play className="h-4 w-4 mr-2" />
          ) : (
            <AlertTriangle className="h-4 w-4 mr-2" />
          )}
          {updating 
            ? 'Actualizando...' 
            : isEnded 
              ? 'Reactivar Concurso'
              : 'Finalizar Concurso'
          }
        </button>
      </div>

      <ContestStatusCard isEnded={isEnded} lastUpdated={lastUpdated} />
    </div>
  );
}